module.exports = __webpack_public_path__ + "1b18d461ce75c75fdb4d7b6ec08b3e65.png";